export default __webpack_public_path__ + "static/media/Plissee 18 mm seitlich ausmessen.e91355f8.jpg";